import React from 'react';
import styled from 'styled-components';

import { ComponentStageType } from '../../types';

import { FullHeightContainer } from '../Containers';
import { ButtonBar } from '../ButtonBar';
import { Button } from '../Button';
import { ContrastDisplay } from '../ContrastDisplay';
import { AppHeader } from '../AppHeader';
import { TestHeader } from '../TestHeader';
import { SliderWrapper } from '../SliderWrapper';
import { RangeSlider } from '../RangeSlider';

import {
    createEnterExitAnimation,
    createFadeInOutAnimation,
} from '../../transitions';
import { animationDelay } from '../../constants';
import { slideHelpText } from '../../testData/contrast';
import { createMarkup } from '../../utils';

interface IProps {
    className?: string;
    stepDisplayNumber: number;
    totalSteps: number;
    fadePercentage: number;
    sliderRange: number[];
    componentStage: ComponentStageType;
    onSliderChange(e: React.ChangeEvent<HTMLInputElement>): void;
    onNextButtonClick(): void;
    onBackButtonClick(): void;
    onCloseButtonClick?(): void;
    onAnimationRest(): void;
}

const BaseContrastTestView: React.FC<IProps> = ({
    className,
    fadePercentage,
    sliderRange,
    componentStage,
    totalSteps,
    onSliderChange,
    onNextButtonClick,
    onBackButtonClick,
    onCloseButtonClick,
    onAnimationRest,
    stepDisplayNumber,
}) => {
    const firstAnimation = createEnterExitAnimation({
        stage: componentStage,
    });
    const secondAnimation = createEnterExitAnimation({
        stage: componentStage,
        delay: animationDelay.second,
    });
    const thirdAnimation = createEnterExitAnimation({
        stage: componentStage,
        delay: animationDelay.third,
    });
    const fourthAnimation = createFadeInOutAnimation({
        stage: componentStage,
        delay: animationDelay.fourth,
        onRest: onAnimationRest,
    });

    return (
        <>
            <AppHeader
                totalSteps={totalSteps}
                stepNumber={stepDisplayNumber}
                greyTheme
                onBackButtonClick={onBackButtonClick}
                onCloseButtonClick={onCloseButtonClick}
            />

            <FullHeightContainer className={className}>
                <TestHeader style={firstAnimation}>
                    <div
                        dangerouslySetInnerHTML={createMarkup(
                            slideHelpText.desktopText
                        )}
                    />
                </TestHeader>
                <ContrastDisplay
                    fadePercentage={fadePercentage}
                    style={secondAnimation}
                />
                <SliderWrapper style={thirdAnimation}>
                    <RangeSlider
                        min={sliderRange[0]}
                        max={sliderRange[1]}
                        value={fadePercentage.toString()}
                        onChange={onSliderChange}
                    />
                </SliderWrapper>
            </FullHeightContainer>
            <ButtonBar>
                <Button style={fourthAnimation} onClick={onNextButtonClick}>
                    klaar
                </Button>
            </ButtonBar>
        </>
    );
};

export const ContrastTestView = styled(BaseContrastTestView)`
    padding-top: 96px;
`;
